export default __webpack_public_path__ + "static/media/jason.ebce12db.png";